import { AWS_BASE, CLOUDFLARE_DEFAULT_BASE } from '../../../../constants'

// tslint:disable-next-line:max-line-length
export const VERIFICATION_IMAGE_URL = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/verification_inprogress_2x.png`
